<template>
  <q-page class="bg-indigo-6">
    <div class="q-px-md absolute-center full-width">
      <div class="text-h5 pc-bold text-white text-center q-mb-lg">
        Register
      </div>
      <q-input
        label="Name"
        type="text"
        standout="bg-white text-indigo-6"
        class="q-mb-md"
        rounded
        dark
        v-model="registerData.name"
      />
      <q-input
        label="Last name"
        type="text"
        standout="bg-white text-indigo-6"
        class="q-mb-md"
        rounded
        dark
        v-model="registerData.lastName"
      />
      <q-input
        label="Email"
        type="email"
        standout="bg-white text-indigo-6"
        class="q-mb-md"
        rounded
        dark
        v-model="registerData.email"
      />
      <q-input
        label="Password"
        type="password"
        standout="bg-white text-indigo-6"
        class="q-mb-md"
        rounded
        dark
        v-model="registerData.password"
      />
      <q-input
        label="Re-Password"
        type="password"
        standout="bg-white text-indigo-6"
        class="q-mb-md"
        rounded
        dark
        v-model="registerData.rePassword"
      />
      <q-btn
        no-caps
        rounded
        color="amber-6"
        text-color="white"
        push
        class="full-width q-py-sm pc-font pc-bold q-mb-md"
        @click="register()"
        :disable="loadingStatus"
      >
        <template v-if="!loadingStatus">
          <q-icon name="how_to_reg" class="on-left" />Create account
        </template>
        <q-spinner-dots color="white" size="1em" v-else />
      </q-btn>
      <div class="row q-mb-lg">
        <router-link to="/login" style="text-decoration: none;">
          <div class="text-subtitle2 text-indigo-2 pc-bold">
            Login
          </div>
        </router-link>
        <q-space />
        <router-link to="/about" style="text-decoration: none;">
          <div class="text-subtitle2 text-indigo-2 pc-bold">
            About
          </div>
        </router-link>
      </div>
    </div>
  </q-page>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      registerData: {
        name: "",
        lastName: "",
        email: "",
        password: "",
        rePassword: "",
      },
    };
  },
  methods: {
    ...mapActions("authStore", ["registerUser"]),

    register() {
      //validations here
      this.registerUser(this.registerData);
    },
  },
  computed: {
    ...mapState("authStore", ["loadingStatus"]),
  },
};
</script>
